import {
  useLoaders,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import {
  GeneralTable,
} from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Button, Grid } from "@mui/material";
import { useMemo, useState } from "react";
import { useFetchUbicaciones } from "@/shared/actions/erp";
import AddIcon from "@mui/icons-material/Add";
import { Ubicaciones } from "@/shared/interfaces/erp/inventario";
import { MRT_ColumnDef } from "material-react-table";

interface ModalUbicacionUsuarioProps {
  onChange: (e: Ubicaciones) => void;
  iconButton?: boolean;
  textButton?: string;
  onlyShow?: boolean;
}

export default function ModalUbicacionUsuario({
  onChange,
  textButton = "Agregar",
}: ModalUbicacionUsuarioProps) {
  ///* State
  const [openModal, setOpenModal] = useState<boolean>(false);

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();

  const {
    pagination,
    setPagination,
  } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  //FETCH
  const {
    isLoading: isloadingUbicacion,
    data: ubicacionRes,
    isRefetching: isRefetchingUbicacion
  } = useFetchUbicaciones({
    page: pageIndex + 1,
    page_size: pageSize,
    estado: true,
    filterByState: false,
    ...filterObject,
  },
    true,
  );

  useLoaders(isloadingUbicacion);


  const columns = useMemo<MRT_ColumnDef<Ubicaciones>[]>(
    () => [
      {
        id: 'nombre',
        accessorKey: 'nombre',
        header: 'nombre',
      },
      {
        id: 'bodega_nombre',
        accessorKey: 'bodega_data.nombre',
        header: 'bodega',
      },
    ],
    []
  );

  return (
    <>
      <Button
        startIcon={<AddIcon />}
        variant="outlined"
        onClick={() => {
          setOpenModal(true)
        }}
      >
        {textButton}
      </Button>

      {openModal && (
        <ScrollableDialogProps
          open={openModal}
          title="Seleccionar"
          onCloseIcon={() => {
            setOpenModal(false);
          }}
          minWidth="60%"
          contentNode={
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <GeneralTable<Ubicaciones>
                  columns={columns}
                  data={ubicacionRes?.data.data || []}
                  isLoading={isloadingUbicacion}
                  isRefetching={isRefetchingUbicacion}
                  enableGlobalFilter={false}
                  pagination={pagination}
                  onPaging={setPagination}
                  rowCount={ubicacionRes?.data?.count}
                  actionsColumnSize={120}
                  canDelete={false}
                  positionActionsColumn='first'
                  enableColumnActions={true}
                  canAdd={true}
                  canEdit={false}
                  onAdd={e => {
                    onChange(e);
                  }}
                  density="comfortable"
                  enableTopToolbar={false}

                  ///* filters - server side
                  enableSorting={false}
                  enableManualFiltering={true}
                  columnFilters={columnFilters}
                  onColumnFiltersChange={setColumnFilters}

                />
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  );
}
